import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=e50a1114&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=ts&"
export * from "./Generic.vue?vue&type=script&lang=ts&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=e50a1114&scoped=true&lang=css&"
import style1 from "./Generic.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50a1114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e50a1114')) {
      api.createRecord('e50a1114', component.options)
    } else {
      api.reload('e50a1114', component.options)
    }
    module.hot.accept("./Generic.vue?vue&type=template&id=e50a1114&scoped=true&", function () {
      api.rerender('e50a1114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/Generic.vue"
export default component.exports